import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { HSTSToast } from "../utils/hstsToast";
import { ToastContainer } from "react-toastify";
import { requestOtp, verifyOtpAndResetPassword } from "../services/otpService";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [otpSent, setOtpSent] = useState(false);

  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

  // Helper function to extract error message
  const getErrorMessage = (error) => {
    if (typeof error === "string") return error;
    if (error?.response?.data?.message) return error.response.data.message;
    if (error?.response?.data) return error.response.data;
    return "An error occurred";
  };

  const sendOtp = async () => {
    if (!email.trim()) {
      HSTSToast("error", "Email is required");
      return;
    }
    try {
      await requestOtp(email);
      HSTSToast("success", "OTP sent to your email!");
      setOtpSent(true);
    } catch (err) {
      console.error(err);
      const errorMsg = getErrorMessage(err);
      HSTSToast("error", errorMsg);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();

    if (!otp.trim()) {
      HSTSToast("error", "OTP is required");
      return;
    }

    if (!newPassword || !confirmPassword) {
      HSTSToast("error", "Please enter new password and confirm password");
      return;
    }

    if (!passwordRegex.test(newPassword)) {
      HSTSToast(
        "error",
        "Password must have at least 8 chars, uppercase, lowercase, number, and special char"
      );
      return;
    }

    if (newPassword !== confirmPassword) {
      HSTSToast("error", "Passwords do not match");
      return;
    }

    try {
      await verifyOtpAndResetPassword(email, otp, newPassword);
      HSTSToast("success", "Password reset successfully!");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      console.error(err);
      const errorMsg = getErrorMessage(err);
      HSTSToast("error", errorMsg);
    }
  };

  return (
    <>
      <div className="wrapper vh-100">
        <div className="row align-items-center h-100">
          <form className="col-lg-3 col-md-6 col-9 mx-auto">
            <div className="card zis-shadow rounded-3">
              <div className="card-body">
                <div className="text-center">
                  <h1
                    className="h6 mb-3 text-black fw-semibold"
                    style={{ fontFamily: "initial", fontSize: "x-large" }}
                  >
                    Reset Password
                  </h1>
                </div>

                <div className="form-group mb-3">
                  <label className="text-black">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    disabled={otpSent}
                  />
                  {!otpSent && (
                    <button
                      type="button"
                      className="btn btn-black mt-2 w-100"
                      onClick={sendOtp}
                    >
                      Send OTP
                    </button>
                  )}
                </div>

                {otpSent && (
                  <>
                    <div className="form-group mb-3">
                      <label className="text-black">OTP</label>
                      <input
                        type="text"
                        className="form-control"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        placeholder="Enter OTP"
                      />
                    </div>

                    <div className="form-group mb-3">
                      <label className="text-black">New Password</label>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          placeholder="Enter new password"
                        />
                        <button
                          type="button"
                          className="input-group-text"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          <i
                            className={`fa ${
                              showPassword ? "fa-eye-slash" : "fa-eye"
                            }`}
                          />
                        </button>
                      </div>
                    </div>

                    <div className="form-group mb-3">
                      <label className="text-black">Confirm Password</label>
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm new password"
                      />
                    </div>

                    <div className="form-group mt-3 mb-3">
                      <button
                        className="btn btn-black w-100 rounded-3"
                        onClick={handleReset}
                      >
                        Reset Password
                      </button>
                    </div>

                    <div className="d-flex form-group">
                      <Link to="/" className="ms-auto text-black">
                        Back to login.
                      </Link>
                    </div>
                  </>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default ResetPassword;
